export default __webpack_public_path__ + "static/media/Illustration.26f97b34.svg";